import { render, staticRenderFns } from "./CustomerTableColsSelector.vue?vue&type=template&id=5b853dde"
import script from "./CustomerTableColsSelector.vue?vue&type=script&lang=js"
export * from "./CustomerTableColsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports